import { fetchOpenConfig } from '@/libs/authService';
import { PublicClientApplication, Configuration, IPublicClientApplication } from '@azure/msal-browser';

let msalInstance: IPublicClientApplication | null = null;
let initializationPromise: Promise<void> | null = null;
let isLoginMicrosoft: boolean = false;

export async function initializeMsal(): Promise<void> {
  console.log('initializeMsal');
  console.log(msalInstance, '-msalInstance');
  if (msalInstance) {
    console.log('msalInstance');
    return;
  }

  console.log(initializationPromise, '-initializationPromise');
  if (initializationPromise) {
    console.log('initializationPromise');
    return initializationPromise;
  }

  initializationPromise = (async () => {
    try {
      const response: any = await fetchOpenConfig();

      if (!response?.data?.config) {
        throw new Error('Invalid config response');
      }

      const config = response.data.config;
      isLoginMicrosoft = config.is_login_microsoft || false;

      if (!config.azure_client_id || !config.azure_authority || !config.redirect_url) {
        console.log('Missing required Azure configuration');
        // throw new Error('Missing required Azure configuration');
      }

      const msalConfig: Configuration = {
        auth: {
          clientId: config.azure_client_id,
          authority: config.azure_authority,
          redirectUri: config.redirect_url,
        },
      };

      const instance = new PublicClientApplication(msalConfig);

      try {
        await instance.initialize();
      } catch (initError) {
        // throw new Error(`Failed to initialize MSAL: ${initError}`);
        console.log('Failed to initialize MSAL: ', initError);
      }

      msalInstance = instance;
      initializationPromise = null;
    } catch (error) {
      msalInstance = null;
      initializationPromise = null;
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error('An unknown error occurred during MSAL initialization');
      }
    }
  })();

  return initializationPromise;
}

export function getMsalInstance(): IPublicClientApplication {
  if (!msalInstance) {
    if (!isLoginMicrosoft) {
      throw new Error('Microsoft login is not enabled.');
    }
    throw new Error('MSAL not initialized. Call initializeMsal() first.');
  }
  return msalInstance;
}

export function getIsLoginMicrosoft(): boolean {
  return isLoginMicrosoft;
}
